export var TMangoPayKYCDocumentType;
(function (TMangoPayKYCDocumentType) {
    TMangoPayKYCDocumentType["IDENTITY_PROOF"] = "IDENTITY_PROOF";
    TMangoPayKYCDocumentType["REGISTRATION_PROOF"] = "REGISTRATION_PROOF";
    TMangoPayKYCDocumentType["ARTICLES_OF_ASSOCIATION"] = "ARTICLES_OF_ASSOCIATION";
    TMangoPayKYCDocumentType["SHAREHOLDER_DECLARATION"] = "SHAREHOLDER_DECLARATION";
})(TMangoPayKYCDocumentType || (TMangoPayKYCDocumentType = {}));
